import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { StructureNodeSelectionComponent } from './structure-node-selection.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        DictionaryModule,
        CommonTranslationModule
    ],
    declarations: [
        StructureNodeSelectionComponent,
    ],
    exports: [StructureNodeSelectionComponent]
})
export class StructureNodeSelectionModule { }
